import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Stack,
  Avatar,
  Select,
  MenuItem,
  IconButton,
  Paper,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { green, pink, red } from "@mui/material/colors";
import LoanCard from "./cards/LoanCard";
import { useAtomValue } from "jotai";
import { LoadingAtom } from "./Atoms";

function App() {
  const loading = useAtomValue(LoadingAtom);

  const bottomText =
    "아래 영역의 텍스트입니다. 내용이 없으면 이 영역은 최소화됩니다.";

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        padding: 2,
        bgcolor: "#f5f5f5", // 연한 회색 배경색 추가
      }}
    >
      {/* 위쪽: 사분면 카드 */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "stretch",
          mb: bottomText ? 2 : 0, // 아래 영역 없으면 margin 제거
          minHeight: 0, // flexbox overflow 방지
        }}
      >
        <Grid container spacing={3} sx={{ flex: 1 }}>
          <Grid size={6}>
            <LoanCard />
          </Grid>

          {[0, 1, 2].map((i) => (
            <Grid size={6} key={i}>
              <Card sx={{ height: "100%" }}>
                <CardContent>
                  <Typography variant="h6">Card {i + 1}</Typography>
                  {/* 카드 내용 */}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      {/* 아래쪽: 텍스트 */}
      {bottomText && (
        <Box sx={{ minHeight: 0 }}>
          <Typography variant="body1">{bottomText}</Typography>
        </Box>
      )}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
}

export default App;
